import { IIncidentTypeCounts } from 'features/admin/model/IIncidentTypeStats';

import { MessageDescriptor } from '@lingui/core';
import { defineMessage } from '@lingui/core/macro';

export interface IncidentTypeOption {
    id: keyof IIncidentTypeCounts;
    label: MessageDescriptor;
    color: string;
}

export const INCIDENT_TYPE_OPTIONS: IncidentTypeOption[] = [
    { id: 'http', label: defineMessage({ id: 'incidentType.http', message: 'HTTP' }), color: '#2a78d6' },
    { id: 'dns', label: defineMessage({ id: 'incidentType.dns', message: 'DNS' }), color: '#008300' },
    { id: 'timeout', label: defineMessage({ id: 'incidentType.timeout', message: 'Таймаут' }), color: '#e87ba4' },
    { id: 'ssl', label: defineMessage({ id: 'incidentType.ssl', message: 'SSL' }), color: '#eda100' },
    {
        id: 'connection',
        label: defineMessage({ id: 'incidentType.connection', message: 'Соединение' }),
        color: '#1baf7a',
    },
    {
        id: 'redirects',
        label: defineMessage({ id: 'incidentType.redirects', message: 'Редиректы' }),
        color: '#eb6834',
    },
    {
        id: 'incorrect-url',
        label: defineMessage({ id: 'incidentType.incorrectUrl', message: 'Некорректный URL' }),
        color: '#4a3aa7',
    },
    {
        id: 'empty-reply',
        label: defineMessage({ id: 'incidentType.emptyReply', message: 'Пустой ответ' }),
        color: '#e34948',
    },
    {
        id: 'check-content',
        label: defineMessage({ id: 'incidentType.checkContent', message: 'Проверка контента' }),
        color: '#0596a6',
    },
    { id: 'other', label: defineMessage({ id: 'incidentType.other', message: 'Другое' }), color: '#a06a2c' },
];
